"use client";

import { c as _c } from "react/compiler-runtime";
import type { PropertyLink } from "@/utils/footer-links";
import { distributeLinksAcrossColumns } from "@/utils/footer-links";
import { type ReactNode } from "react";
import { FooterClient } from "./client";

// Fallback static links with proper URLs
const fallbackQuickLinks: PropertyLink[] = [{
  label: "Apartment In BTM Layout",
  href: "/bengaluru/apartments-in-btm-layout"
}, {
  label: "Apartment In Banashankari",
  href: "/bengaluru/apartments-in-banashankari"
}, {
  label: "Apartment In Bellandur",
  href: "/bengaluru/apartments-in-bellandur"
}, {
  label: "Apartment In Electronic City",
  href: "/bengaluru/apartments-in-electronic-city"
}, {
  label: "Apartment In Horamavu",
  href: "/bengaluru/apartments-in-horamavu"
}, {
  label: "Apartment In HSR Layout",
  href: "/bengaluru/apartments-in-hsr-layout"
}, {
  label: "Apartment In JP Nagar",
  href: "/bengaluru/apartments-in-jp-nagar"
}, {
  label: "Apartment In K R Puram",
  href: "/bengaluru/apartments-in-k-r-puram"
}, {
  label: "Apartment In Kalyan Nagar",
  href: "/bengaluru/apartments-in-kalyan-nagar"
}, {
  label: "Apartment In Whitefield",
  href: "/bengaluru/apartments-in-whitefield"
}];
interface FooterHybridProps {
  // Pre-fetched data from server (for SSR)
  initialLinkColumns?: PropertyLink[][];
  seoContent?: ReactNode;
}
export function FooterHybrid(t0) {
  const $ = _c(5);
  const {
    initialLinkColumns,
    seoContent
  } = t0;
  let t1;
  if ($[0] !== initialLinkColumns) {
    t1 = initialLinkColumns || distributeLinksAcrossColumns(fallbackQuickLinks, 4);
    $[0] = initialLinkColumns;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const linkColumns = t1;
  let t2;
  if ($[2] !== linkColumns || $[3] !== seoContent) {
    t2 = <FooterClient linkColumns={linkColumns} seoContent={seoContent} />;
    $[2] = linkColumns;
    $[3] = seoContent;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}